import React, {useEffect, useRef, useContext } from 'react';
import { HomepageContext } from '../../context/context';


export const Particle = props => {
    const canvasRef = useRef(null);
    const { isSparkle } = useContext(HomepageContext)
    useEffect(() => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext('2d');
        let w, h, balls = [];
        let mouse = {
            x: undefined,
            y: undefined
        };
        let rgb = [
            "rgb(199, 199, 199)",
            "rgb(146, 146, 146)",
            "rgb(152, 152, 152)",
            "rgb(155, 155, 155)",
            "rgb(190, 190, 190)",
            "rgb(170, 170, 170)",
            "rgb(195, 195, 195)",   
        ]
        const init = () => {
            resizeReset();
            animationLoop()
        };
        const resizeReset = () => {
            w = canvas.width = window.innerWidth;
            h = canvas.height = window.innerHeight;
        };
        const animationLoop = () => {
            ctx.clearRect(0, 0, w, h);
            ctx.globalCompositeOperation = "lighter";
            drawBalls()
            let temp = [];
            for (let i = 0; i < balls.length; i++) {
                if (balls[i].time <= balls[i].ttl) {
                    temp.push(balls[i]);
                }
            }
            balls = temp;

            requestAnimationFrame(animationLoop);
        };
        const drawBalls = () => {
            for (let i = 0; i < balls.length; i++) {
                balls[i].update();
                balls[i].draw();
            }
        };
        const mousemove = (e) => {
            mouse.x = e.x;
            mouse.y = e.y;

            for (let i = 0; i < 3; i++) {
                balls.push(new Ball());
            }
        };
        const mouseout = () => {
            mouse.x = undefined;
            mouse.y = undefined;
        };
        const getRandomInt = (min, max) => {
            return Math.round(Math.random() * (max - min)) + min;
        }

        const easeOutQuart = (x) => {
            return 1 - Math.pow(1 - x, 4);
        };
       
        class Ball {
            constructor() {
                this.start = {
                    x: mouse.x + getRandomInt(-20, 20),
                    y: mouse.y + getRandomInt(-20, 20),
                    size: getRandomInt(.05, 2)
                }
                this.end = {
                    x: this.start.x + getRandomInt(-20, 20),
                    y: this.start.y + getRandomInt(-20, 20),
                };
                this.x = this.start.x;
                this.y = this.start.y;
                this.size = this.start.size;
                this.style = rgb[getRandomInt(0, rgb.length - 1)];
                this.time = 0;
                this.ttl = 1220;
            }
            draw() {
                ctx.fillStyle = this.style;
                ctx.beginPath();
                ctx.arc(this.x, this.y, this.size, 0, Math.PI*2);
                ctx.closePath();
                ctx.fill();;
            }
            update() {
                if (this.time <= this.ttl) {
                    let progress = 1 - (this.ttl - this.time) / this.ttl;
                    
                    this.size = this.start.size * (1 - easeOutQuart(progress));
                    this.x = this.x + (this.end.x - this.x) * 0.005;
                    this.y = this.y + (this.end.y - this.y) * 0.005;
                } 
                this.time++;
            }
        }
        

        if (document.readyState !== 'loading') {
            init();
        };
        window.addEventListener("resize", resizeReset);
        window.addEventListener("mousemove", mousemove);
        window.addEventListener("mouseout", mouseout);

    }, [canvasRef]);

    return (
        <>
        <div className={isSparkle ? 's' : 'hidden'}>
            <canvas ref={canvasRef} {...props}/>
        </div>
        </>
       
    );
};
